// extracted by mini-css-extract-plugin
export default {"rating":"IE-z","numberOfStars":"JE-z","count":"KE-z","barGraphSpacing":"LE-z","barGraph":"ME-z"};